import React from 'react'
import Header from './Header'
import Footer from './Footer'

/**
 * Layout - Main application layout wrapper
 * Provides consistent structure and background
 */
const Layout = ({ children, className = '' }) => {
  return (
    <div className={`min-h-screen bg-primary-900 noise-bg flex flex-col ${className}`}>
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
